import { NavigationEnd, Router } from '@angular/router';
import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnInit,
  AfterViewInit
} from '@angular/core';

import {
  Brand,
  PageTitle,
} from '../../../../../utils/models/layout.interface';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { filter, map } from 'rxjs/operators';
import { _metrics, _projectLinks } from 'src/app/shared/constants/sonar';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { generateProjectsBadges } from 'src/app/shared/functions/functionGeneric';


@Component({
  selector: 'app-topnavbar',
  templateUrl: './topnavbar.component.html',
  styleUrls: ['./topnavbar.component.scss'],
})
export class TopnavbarComponent implements OnInit {
  @Input() pageTitles: PageTitle[];
  @Input() title: string;
  @Input() breakpoint: boolean;
  @Input() brand: Brand;
  @Input() link;
  @Output() collapse = new EventEmitter();
  @Output() changeGantt = new EventEmitter();

  @Input() drawer: any;

  fullScreen = false;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  //sonar badge
  apiUrl = environment.apiUrl
  currentProject = localStorage.getItem('project') || '';
  projectLinks = _projectLinks
  badges = []
  currentUrl: string;
  pagesNav = [];

  constructor(
    public router: Router,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer
  ) {
    if(!localStorage.getItem('environment')){
      this.router.navigate(['autenticacao/login/system-access'])
    }

    
  }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.generateCrumb(this.currentUrl)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects;
          this.generateCrumb(this.currentUrl)

      });

      generateProjectsBadges(this.http, this.apiUrl, this.currentProject, this.projectLinks, ['coverage', 'alert_status'], this.sanitizer).subscribe(res => {
        this.badges = res;
      })
  }


  generateCrumb(url: string){
    this.pagesNav = []
    const parts = url.split('/').filter(Boolean);
    parts.forEach((part) => {
      const pathFound = this.pageTitles.find(page => page.path.includes(part))
      const crumb = pathFound ? pathFound.name : part;
      this.pagesNav.push(crumb);
    });
    

  }
  

  selectTitle(path: string): Object {
  if(localStorage.getItem('environmentName') && this.pageTitles.find((page)=>{return path.includes(page.path)})?.name){
    return [localStorage.getItem('environmentName'),this.pageTitles.find((page)=>{return path.includes(page.path)}).name]
  }

   const tempPath = path.split(';')[0]
    return this.pageTitles.find((page) => page.path === tempPath)
      ? this.pageTitles.find((page) => page.path === tempPath).name.split('-')
      : null;
  }

  returnTitleTopNavbar(obj: any): string {
    return obj?.length > 0 ? obj[obj.length - 1].trim() : 'Casos de Teste';
  }

  toggleFullScreen(): void {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        this.fullScreen = true;
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          this.fullScreen = false;
        });
      }
    }
  }

  sendCollapse() {
    this.collapse.emit(true);
  }

  openMenu(){
    this.drawer.toggle()
  }

  handleClick(value1, value2) {
    if(value1 === localStorage.getItem('environmentName')){
      this.router.navigate(['/system-access']);
    }


    const indexOf = value2.indexOf(value1);
    const newArray = indexOf !== -1 ? value2.slice(0, indexOf + 1) : value2;

    let resultado = newArray.join('-');
    resultado = resultado.replace(/\s+$/, '');

    let breakpoint: string
    this.pageTitles.forEach((item,index) => {
      if(item.name === resultado){
        breakpoint = item.path
      }
    })
    if(breakpoint){
      this.router.navigate([breakpoint])
    }
  }

}
